import { render, staticRenderFns } from "./Mailings.vue?vue&type=template&id=efcf52fa&scoped=true&"
import script from "./Mailings.vue?vue&type=script&lang=js&"
export * from "./Mailings.vue?vue&type=script&lang=js&"
import style0 from "./Mailings.vue?vue&type=style&index=0&id=efcf52fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcf52fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VIcon,VTextField})
